import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';
import { ICreateDriverForm } from '@/pages/ChauffeurCreate/types';
import { TCountryCodes } from '@/shared/models/country-code';

interface IParams {
  formValues: ICreateDriverForm;
  countryCode: TCountryCodes;
}

const createDriver = createAsyncThunk(
  `${namespace}/create-driver`,
  async ({ formValues, countryCode }: IParams) => {
    const [driver, validationErrors] = await driverAPI.createDriver(formValues, countryCode);

    return { validationErrors, driver };
  },
);

export { createDriver };
